import styled from "styled-components";
import { capitalize } from "../../utils/textFormats";

export default function ColorLegend({ object }) {
  return (
    <LegendContainer>
      {Object.entries(object).map(([key, value]) => (
        <LegendItem key={key}>
          <span>{capitalize(key)}</span>
          <div className="colors">
            {value.map((color, index) => (
              <div key={index} className="color" style={{ backgroundColor: color }}></div>
            ))}
          </div>
        </LegendItem>
      ))}
    </LegendContainer>
  );
}

const LegendContainer = styled.div`
  display: grid;
  margin-left: 26px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    font-size: 14px;
  }

  .colors {
    display: flex;
    gap: 1px;

    .color {
      width: 14px;
      height: 14px;
      border: 0.5px solid #c6ccec;
      border-radius: 4px;
    }
  }
`;
